import React, { ReactNode, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { MODALS_MAP, MODAL_KEYS } from '../../constants';
import { ModalState } from '../../recoil/modal/modal.state';
import Container from '../containers/container';
import { HStack } from '../layouts/stack.layout';

type Props = {
  children?: ReactNode;
  className?: string;
  modals: MODALS_MAP;
};

type SCProps = {
  children?: any;
  name: MODAL_KEYS;
};

const styles = {
  container:
    'z-[130] fixed top-0 left-0 w-screen h-screen bg-white/10 backdrop-blur-md',
  overlay: 'z-[140] absolute top-0 left-0 w-full h-full',
  wrapper: 'items-center w-full h-full',
  'modal-container':
    'flex-1 mobile:w-full mobile:h-full tablet-lg:min-w-[300px] tablet-lg:max-w-[550px] tablet-lg:min-h-[300px] tablet-lg:max-h-[600px] z-[150] overflow-auto tablet-lg:rounded-lg relative bg-[#08080D]',
};

function ModalController(props: Props) {
  const [modal, setModal] = useRecoilState(ModalState);
  const { children } = props;

  const closeModal = () => {
    setModal((prev) => ({ ...prev, current: null, shouldShow: false }));
  };

  useEffect(() => {
    modal.shouldShow
      ? document.querySelector('body')?.classList.add('no-scroll')
      : document.querySelector('body')?.classList.remove('no-scroll');
  });

  const Modals = React.Children.map(children, (child: any) =>
    child.type.displayName === 'Modal' ? (
      <>
        {modal.current === child.props.name && <Container>{child}</Container>}
      </>
    ) : null
  );

  return (
    <>
      {modal.shouldShow && (
        <Container extensions={styles.container}>
          <Container onClick={closeModal} extensions={styles.overlay} />
          <HStack justify="center" extensions={styles.wrapper}>
            <Container extensions={styles['modal-container']}>
              {Modals}
            </Container>
          </HStack>
        </Container>
      )}
    </>
  );
}

const Modal = (props: SCProps) => props.children;
Modal.displayName = 'Modal';

ModalController.Modal = Modal;

export default ModalController;
